export class GlobalVariable {
    lastUrl: string;
    constructor() {
        this.lastUrl = '';
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/global.variables.ts